import * as React from "react";
import * as ReactDOM from "react-dom/client";
import App from "./App";
import "@theme/styles.scss";
import { randomRange as r } from "scripts/FunctionsBundle";
// import reportWebVitals from "./reportWebVitals";

const el = document.getElementById("root")!;

// RANDOM MESH
const c = [
  // "var(--color-tertiary-1)", // celeste -

  // "var(--color-objects-3)", // blanco -
  "var(--color-background-4)", // blanco - celeste
  "var(--color-objects-1)", // blanco +
  "var(--color-objects-4)", // celeste +

  "var(--color-objects-2)", // verde
  "var(--color-background-1)", // beige -
  "var(--color-background-2)", // beige +

  "var(--color-background-3)", // naranja +
  // "var(--color-secondary-4)", // azul +
  "var(--color-tertiary-3)", // azul -
];
el.style.backgroundImage = "";
while (c.length > 0) {
  el.style.backgroundImage += `radial-gradient(at ${r(0, 100)}% ${r(
    0,
    100
  )}%, ${
    c.splice(r(0, Math.min(c.length - 1, 2)), 1)[0]
  } 0px, transparent 50%),`;
}
el.style.backgroundImage = el.style.backgroundImage.slice(0, -1);

const root = ReactDOM.createRoot(el);
root.render(
  <React.StrictMode>
    <App />
    {/* <div className="screen">
      <h1>Estamos en Mantenimiento!</h1>
    </div> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
